export enum ProgrammeSettingsView {
	General = 'general',
	Members = 'members',
	Loans = 'loans',
	Securities = 'securities',
	User = 'user',
	MasterDocuments = 'documents',
	KycSettings = 'kyc',
	InvestorData = 'data',
	Tax = 'tax',
	Classifiers = 'classifiers',
	EmailTemplates = 'email-templates',
	AutomatedEmails = 'automated-emails',
}
